import script from "./WordPressCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./WordPressCreate.vue?vue&type=script&setup=true&lang=js"

import "./WordPressCreate.vue?vue&type=style&index=0&id=37c5f606&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c5f606"]])

export default __exports__